import React, { useEffect, useId } from "react";
import Icons from "../../myIcon/Icons";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Link } from "react-router-dom";

export default function GoaGallery({
    images = [],
    heading = "",
}) {
    const id = useId().replace(/:/g, "");
    const galleryId = `gallery-${id}`;

    useEffect(() => {
        let fb;
        let cancelled = false;

        import("@fancyapps/ui").then((mod) => {
            if (cancelled) return;

            fb = mod.Fancybox;
            fb.bind(`[data-fancybox="${galleryId}"]`, {});
        });

        return () => {
            cancelled = true;

            if (fb) {
                fb.unbind(`[data-fancybox="${galleryId}"]`);
            }
        };
    }, [galleryId]);

    return (
        <section className="goa-gallery">
            <div className="big-container">
                <div className="row justify-content-center">

                    {heading && (
                        <div className="col-lg-9">
                            <h4 className="heading center-heading">
                                {heading}
                            </h4>
                        </div>
                    )}

                    <div className="col-lg-12">
                        <div className="goagallery-box">
                            {Array.from(
                                { length: Math.ceil(images.length / 2) },
                                (_, groupIndex) => (
                                    <div
                                        key={groupIndex}
                                        className={
                                            groupIndex % 2 === 0
                                                ? "goagallery-small"
                                                : "goagallery-big"
                                        }
                                    >
                                        {images
                                            .slice(groupIndex * 2, groupIndex * 2 + 2)
                                            .map((image, index) => (
                                                <a
                                                    key={image.src}
                                                    href={image.src}
                                                    data-fancybox={galleryId}
                                                >
                                                    <img
                                                        src={image.src}
                                                        className="img-responsive"
                                                        alt={
                                                            image.alt ||
                                                            `Gallery image ${groupIndex * 2 + index + 1}`
                                                        }
                                                        loading="lazy"
                                                    />
                                                    <span>
                                                        <Icons name="expand" />
                                                    </span>
                                                </a>
                                            ))}
                                    </div>
                                )
                            )}
                        </div>

                        <div className="text-center">
                            <Link
                                to="/resort-de-coracao-goa/gallery"
                                className="default-btn color-btn"
                            >
                                View Full Gallery
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}